(() => {
  if (customElements.get('luemas-services-marquee')) return;

  class LuemasServicesMarquee extends HTMLElement {
    constructor() {
      super();
      this.refresh = this.refresh.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-services-viewport]');
      this.track = this.querySelector('[data-services-track]');
      this.group = this.querySelector('[data-services-group]');
      this.cloneTemplate = this.querySelector('[data-services-clone]');
      this.speed = Math.max(Number(this.dataset.speed) || 35, 1);
      this.autoScroll = this.dataset.autoScroll === 'true';

      if (!this.viewport || !this.track || !this.group || !this.autoScroll) return;

      this.refresh();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.refresh);
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
      } else {
        window.addEventListener('resize', this.refresh, { passive: true });
      }

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', () => {
          this.track.style.animationPlayState = 'paused';
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.track.style.animationPlayState = '';
        });
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.refresh);
    }

    refresh() {
      if (!this.autoScroll || !this.track || !this.group || !this.viewport) return;

      this.track.querySelectorAll('[data-services-generated-clone]').forEach((node) => node.remove());

      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap || style.gap) || 24;
      const groupWidth = this.group.scrollWidth;
      if (!groupWidth) return;

      const template = this.cloneTemplate || this.group;
      const minimumTrackWidth = Math.max(this.viewport.clientWidth * 2.25, groupWidth * 2 + gap);
      let safety = 0;

      while (this.track.scrollWidth < minimumTrackWidth && safety < 8) {
        const clone = template.cloneNode(true);
        clone.removeAttribute('data-services-group');
        clone.removeAttribute('data-services-clone');
        clone.setAttribute('data-services-generated-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, select, textarea').forEach((el) => el.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
        safety += 1;
      }

      const duration = Math.max((groupWidth + gap) / this.speed, 10);
      this.style.setProperty('--luemas-services-duration', `${duration}s`);
      this.style.setProperty('--luemas-services-travel', `${groupWidth + gap}px`);
      this.classList.add('is-ready');
    }
  }

  customElements.define('luemas-services-marquee', LuemasServicesMarquee);
})();
